const ITEM_TYPES = [
    {
        key: 'pet',
        text: 'Питомец'
    },
    { key: 'egg', text: 'Яйцо' },
    { key: 'potion', text: 'Зелье' },
    {
        key: 'transport',
        text: 'Транспорт',
        subtypes: [
            { key: 'scooters', text: 'Самоткаты' },
            { key: 'skateboards', text: 'Скейтборды' },
            { key: 'legendary_gift_vehicles', text: 'Легендарный гифт транспорт' },
            { key: 'snowboards', text: 'Сноуборды' },
            { key: 'event_vehicles', text: 'Ивентовый' },
            { key: 'vehicle_dealership', text: 'Транспорт из автосалона' },
            { key: 'premium_vehicles', text: 'Премиум' },
            { key: 'star_rewards_vehicles', text: 'Star Rewards' },
            { key: 'miscellaneous_vehicles', text: 'Прочий' }
        ]
    }
]

const ALL_RARITIES = [
    { key: 'common', text: 'Обычный' },
    { key: 'uncommon', text: 'Необычный' },
    { key: 'rare', text: 'Редкий' },
    { key: 'ultra_rare', text: 'Ультра-редкий' },
    { key: 'legendary', text: 'Легендарный' }
]

const ITEM_PROPERTIES = [
    { key: 'missing', text: 'Отсутствуют' },
    { key: 'flyable', text: 'Флай' },
    { key: 'rideable', text: 'Райд' }
]

const ALL_LEVELS = [
    {
        key: 'default',
        text: 'Обычный',
        ages: [
            { key: 'newborn', text: 'Newborn' },
            { key: 'junior', text: 'Junior' },
            { key: 'pre_teen', text: 'Pre-Teen' },
            { key: 'teen', text: 'Teen' },
            { key: 'post_teen', text: 'Post-Teen' },
            { key: 'full_grown', text: 'Full Grown' }
        ]
    },
    {
        key: 'neon',
        text: 'Неон',
        ages: [
            { key: 'reborn', text: 'Reborn' },
            { key: 'twinkle', text: 'Twinkle' },
            { key: 'sparkle', text: 'Sparkle' },
            { key: 'flare', text: 'Flare' },
            { key: 'sunshine', text: 'Sunshine' },
            { key: 'luminous', text: 'Luminous' }
        ]
    },
    {
        key: 'mega_neon',
        text: 'Мега-Неон'
    }
]

const DEFAULT_FILTERS = {
    type: 'all',
    rarity: 'all',
    age: 'all',
    name: '',
    types: {
        egg: false,
        pet: false,
        potion: false,
        transport: false
    },
    rarities: {
        common: false,
        uncommon: false,
        rare: false,
        ultra_rare: false,
        legendary: false
    },
    properties: {
        flyable: false,
        rideable: false,
        missing: false
    },
    levels: {
        default: false,
        neon: false,
        mega_neon: false
    },
    ages: {
        newborn: false,
        junior: false,
        pre_teen: false,
        teen: false,
        post_teen: false,
        full_grown: false,
        reborn: false,
        twinkle: false,
        sparkle: false,
        flare: false,
        sunshine: false,
        luminous: false
    },
    subtypes: {
        transport: {
            scooters: false,
            skateboards: false,
            snowboards: false,
            legendary_gift_vehicles: false,
            event_vehicles: false,
            vehicle_dealership: false,
            premium_vehicles: false,
            star_rewards_vehicles: false,
            miscellaneous_vehicles: false
        }
    }
}

module.exports = {
    ITEM_TYPES,
    ALL_RARITIES,
    ITEM_PROPERTIES,
    ALL_LEVELS,
    DEFAULT_FILTERS
}
